function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".signal_svg__cls-1{fill:#fff}"));

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  className: "signal_svg__cls-1",
  d: "M137.31 225a12.5 12.5 0 0025 0V75a12.5 12.5 0 00-25 0zm0 0M12.31 75A12.5 12.5 0 00-.19 87.5v125a12.5 12.5 0 0025 0v-125A12.5 12.5 0 0012.31 75zm0 0M118.56 200V100a12.5 12.5 0 00-25 0v100a12.5 12.5 0 0025 0zm0 0M62.31 187.5a12.5 12.5 0 0012.5-12.5v-50a12.5 12.5 0 00-25 0v50a12.5 12.5 0 0012.5 12.5zm0 0M206.06 200V100a12.5 12.5 0 00-25 0v100a12.5 12.5 0 0025 0zm0 0M287.31 75a12.5 12.5 0 00-12.5 12.5v125a12.5 12.5 0 0025 0v-125a12.5 12.5 0 00-12.5-12.5zm0 0M237.31 112.5a12.5 12.5 0 00-12.5 12.5v50a12.5 12.5 0 0025 0v-50a12.5 12.5 0 00-12.5-12.5zm0 0M137.31 287.5a12.5 12.5 0 0025 0V275a12.5 12.5 0 00-25 0zm0 0M149.81 37.5a12.5 12.5 0 0012.5-12.5V12.5a12.5 12.5 0 00-25 0V25a12.5 12.5 0 0012.5 12.5zm0 0"
});

var SvgSignal = function SvgSignal(props) {
  return React.createElement("svg", _extends({
    id: "signal_svg__Capa_1",
    "data-name": "Capa 1",
    viewBox: "0 0 300 300"
  }, props), _ref, _ref2);
};

export default SvgSignal;